//import VisualComponent from "../../components/flux360/components/VisualComponent";

import {Request} from './Request';
//import handleRequests from '@/components/flux360/components/PanoramaScene/handleRequests';

class RuntimeState{
    constructor( {
        paused = undefined,
        pauseType = "pause",
        duration = -1,
        timeStamp = -1,
        waitingForResume = undefined
    }= {} ) {
        //console.log("Constructor runtimestate");
        Object.assign( this, { paused, duration, timeStamp, pauseType, waitingForResume} );
        this.requests = [];
    }

    requestPlay(user){
        console.log("REQUEST Play");
        var playRequest = new Request(user, Request.RequestType.Play);
        playRequest.requestType = Request.RequestType.Play;
        playRequest.requestedBy = user;
        playRequest.timeStamp = new Date().getTime();
        this.requests.push(playRequest);
    }
    requestPause(user){
        console.log("REQUEST PAUSE");
        var pauseRequest = new Request(user, Request.RequestType.Pause);
        pauseRequest.requestType =  Request.RequestType.Pause;
        pauseRequest.timeStamp = new Date().getTime();
        this.requests.push(pauseRequest);
    }
    requestStop(user){
        var stopRequest = new Request();
        stopRequest.requestType = Request.RequestType.Stop;
        stopRequest.requestedBy = user;
        stopRequest.timeStamp = new Date().getTime();
        this.requests.push(stopRequest);
    }
    requestReset(user){
        var resetRequest = new Request();
        resetRequest.requestType = Request.RequestType.Reset;
        resetRequest.requestedBy = user;
        resetRequest.timeStamp = new Date().getTime();
        this.requests.push(resetRequest);
    }
    requestJumpToTimePosition (user, time){
        var jumpToTimePositionRequest = new Request();
        jumpToTimePositionRequest.requestType = Request.RequestType.JumpToTimePosition;
        jumpToTimePositionRequest.requestedBy = user;
        jumpToTimePositionRequest.timeStamp = new Date().getTime();
        jumpToTimePositionRequest.timeToJumpTo = time;
        this.requests.push(jumpToTimePositionRequest);
    }
    requestChangeVolume(user,volume){
        var changeVolumeRequest = new Request();
        changeVolumeRequest.requestType = Request.RequestType.ChangeVolume;
        changeVolumeRequest.requestedBy = user;
        changeVolumeRequest.timeStamp = new Date().getTime();
        changeVolumeRequest.volume = volume;
        this.requests.push(changeVolumeRequest);
    }
}

RuntimeState.PauseType = Object.freeze({
    Explicit: "ExplicitPause",
    Implicit: "ImplicitPause"
})

class Prefab
{
    constructor( {
        id = -1,
        type = undefined      
    }= {} ) {
        Object.assign( this, { id, type } );
        this.runtimeState = new RuntimeState();
    }

    setID( value ) { this.id = value; return this; }
    setType( value ) { this.type = value; return this; }

    getID() { return this.id; }
    getType() { return this.type; }


    // Parses this prefab type from the given JSON object
    parseFromJSON( json ) {
        // not implemented...
        if( json && json.idName ) {
            // Seems to be a datatype from the CMS...
            this
            .setID( json.idName )
            .setType( json.presetType );
        } else {
            // Unknown datatype...
            console.error("Trying to parse unknown filetype");
        }
        return this;
    }

    createFromJSON() {

    }

    create(  ) {
    }

    toJSON() {
        return {
            id: this.id,
            type: this.type
        };
    }

    isOfType() {
        return false;
    }

    getContentIDs(){
        return [];
    }
}

Prefab.PrefabType = Object.freeze({
    Situation: "Situation",
    SituationImage: "RoomImage",
    SituationVideo: "RoomVideo",
    VisualPrefab: "VisualPrefab",
    ContentPrefab: "ContentPrefab",
    AudioContent: "RoomContentAudio",
    ImageContent: "RoomContentImage",
    VideoContent: "RoomContentVideo",
    Transition: "RoomContentJumper",
    TextContent: "RoomContentText",
    URLButton: "Button, der einen Weblink öffnet",
    Application360: "Application360",
    Viewer3D: "RoomContent3DViewer",
    SphereContent: "RoomSphereContent",
  })


class Application360 extends Prefab
{
    constructor( {
        id = -1,
        name = undefined,
        packageName = undefined, 
        description = undefined,
        startSituationID = undefined,
        backgroundColor = undefined,
        splashScreens = undefined,
        splashScreenDisplayTime = undefined,
        startInteractionType = undefined,
        type = undefined
    } = {} ) {
        super( { id, type } );
        this.setType( Prefab.PrefabType.Application360 );
        Object.assign( this, { name, description, packageName, startSituationID, backgroundColor, splashScreens, splashScreenDisplayTime, startInteractionType } );
    }

    isOfType( type ) {
        return type === Prefab.PrefabType.Application360 || super.isOfType( type );
    }

    setName( value ) { this.name = value; return this; }
    setDescription( value ) { this.description = value; return this; }
    setPackageName( value ) { this.packageName = value; return this; }
    setStartSituationID( value ) { this.startSituationID = value; return this; }
    setBackgroundColor( value ) { this.backgroundColor = value; return this; }
    setSplashScreen( value ) { this.splashScreen = value; return this; }
    setSplashScreenDisplayTime( value ) { this.splashScreenDisplayTime = value; return this; }
    setStartInteractionType( value ) { this.startInteractionType = value; return this; }

    getName() { return this.name; }
    getDescription() { return this.description; }
    getPackageName() { return this.packageName; }
    getStartSituationID() { return this.startSituationID; }
    getBackgroundColor() { return this.backgroundColor; }
    getSplashScreen() { return this.splashScreen; }
    getSplashScreenDisplayTime() { return this.splashScreenDisplayTime; }
    getStartInteractionType() { return this.startInteractionType; }

    // Parses this prefab type from the given JSON object
    parseFromJSON( json ) {
        // not implemented...
        if( json && json.presetType ) {
            // not implemented...
            super.parseFromJSON( json );

            // Seems to be a datatype from the CMS...
            this
            .setStartSituationID( json.start_room )
            .setBackgroundColor( json.background_color )
            .setSplashScreen( json.splashscreens )
            .setSplashScreenDisplayTime( json.splashscreen_display_time )
            .setStartInteractionType( json.start_interaction_type )
        } else {
            // Unknown datatype...
            console.error("Trying to parse unknown filetype");
        }
        return this;
    }

    createFromJSON( json ) {
        return new Application360().parseFromJSON( json );
    }

    create( json ) {
        var ap = new Application360();
        Object.assign( ap, json );
        return ap;
    }

    toJSON() {
        var rv = super.toJSON();
        rv.name = this.name;
        rv.description = this.description;
        rv.packageName = this.packageName;
        rv.startSituationID = this.startSituationID;
        rv.backgroundColor = this.backgroundColor;
        rv.splashScreen = this.splashScreen;
        rv.splashScreenDisplayTime = this.splashScreenDisplayTime;
        rv.startInteractionType = this.startInteractionType;
        return rv;
    }
}

class Situation extends Prefab
{
    constructor( {
        id = -1,
        name = undefined,
        description = undefined,
        thumbnail = undefined,
        autoJump = undefined,
        autoJumpAtTime = undefined,
        autoJumpTarget = undefined,
        loop = undefined,
        videoWidth = undefined,
        videoHeight = undefined,
        exposedInUI = undefined,
        exposedUIHeader = undefined,
        type = undefined
    } = {} ) {
        super( { id, type } );
        Object.assign( this, {name, description, thumbnail, autoJump, autoJumpAtTime, autoJumpTarget, loop, videoWidth, videoHeight, exposedInUI, exposedUIHeader });
    }
    isOfType( type ) {
        return type === Prefab.PrefabType.Situation || super.isOfType( type );
    }

    setName( value ) { this.name = value; return this; }
    setDescription( value ) { this.description = value; return this; }
    setThumbnail( value ) { this.thumbnail = value; return this; }
    setAutoJump( value ) { this.autoJump = value; return this; }
    setAutoJumpAtTime( value ) { this.autoJumpAtTime = value; return this; }
    setAutoJumpTarget( value ) { this.autoJumpTarget = value; return this; }
    setLoop( value ) { this.loop = value; return this; }
    setVideoWidth( value ) { this.videoWidth = value; return this; }
    setVideoHeight( value ) { this.videoHeight = value; return this; }
    setExposedInUI( value ) { this.exposedInUI = value; return this; }
    setExposedUIHeader( value ) { this.exposedUIHeader = value; return this; }

    getName() { return this.name; }
    getDescription() { return this.description; }
    getThumbnail() { return this.thumbnail; }
    getAutoJump() { return this.autoJump; }
    getAutoJumpAtTime() { return this.autoJumpAtTime; }
    getAutoJumpTarget() { return this.autoJumpTarget; }
    getLoop() { return this.loop; }
    getVideoWidth() { return this.videoWidth; }
    getVideoHeight() { return this.videoHeight; }
    getExposedInUI() { return this.exposedInUI; }
    getExposedUIHeader() { return this.exposedUIHeader; }
    getSituationID() { return this.getID(); }

    // Parses this prefab type from the given JSON object
    parseFromJSON( json ) {
        // not implemented...
        if( json && json.presetType ) {
            // not implemented...
            super.parseFromJSON( json );

            // Seems to be a datatype from the CMS...
            this
            .setName( json.display_name)
            .setDescription( json.display_description )
            .setThumbnail( json.thumbnail )
            .setAutoJump( json.autoJump )
            .setAutoJumpAtTime( json.autoJumpAtTime )
            .setAutoJumpTarget( json.autoJumpTarget )
            .setLoop( json.loop )
            .setVideoWidth( json.videoWidth )
            .setVideoHeight( json.videoHeight )
            .setExposedInUI( json.exposedInUI )
            .setExposedUIHeader( json.exposedUIHeader )
        } else {
            // Unknown datatype...
            console.error("Trying to parse unknown filetype");
        }
        return this;
    }

    createFromJSON( json ) {
        return new Situation().parseFromJSON( json );
    }

    
    create( json ) {
        var s = new Situation();
        Object.assign( s, json );
        return s;
    }

    toJSON() {
        var rv = super.toJSON();
        rv.name = this.name;
        rv.description = this.description;
        rv.thumbnail = this.thumbnail;
        rv.autoJump = this.autoJump;
        rv.autoJumpAtTime = this.autoJumpAtTime;
        rv.autoJumpTarget = this.autoJumpTarget;
        rv.loop = this.loop;
        rv.videoWidth = this.videoWidth;
        rv.videoHeight = this.videoHeight;
        rv.exposedInUI = this.exposedInUI;
        rv.exposedUIHeader = this.exposedUIHeader;
        return rv;
    }
}

class SituationImage extends Situation
{
    constructor( {
        id = -1,
        name = undefined,
        description = undefined,
        thumbnail = undefined,
        autoJump = undefined,
        autoJumpAtTime = undefined,
        autoJumpTarget = undefined,
        loop = undefined,
        videoWidth = undefined,
        videoHeight = undefined,
        exposedInUI = undefined,
        exposedUIHeader = undefined,
        sphereImageID = undefined,
        type = undefined
    } = {} ) {
        super( { id, type, name, description, thumbnail, autoJump, autoJumpAtTime, autoJumpTarget, loop, videoWidth, videoHeight, exposedInUI, exposedUIHeader } );
        this.setType( Prefab.PrefabType.SituationImage );
        this
            .setSphereImageID( sphereImageID )
    }
    isOfType( type ) {
        return type === Prefab.PrefabType.SituationImage || super.isOfType( type );
    }

    setSphereImageID( value ) { this.sphereImageID = value; return this; }    
    getSphereImageID() { return this.sphereImageID; }

    // Parses this prefab type from the given JSON object
    parseFromJSON( json ) {
        // not implemented...
        if( json && json.presetType ) {
            // not implemented...
            super.parseFromJSON( json );

            // Seems to be a datatype from the CMS...
            this.setSphereImageID( json.roomSphereImage );
          
        } else {
            // Unknown datatype...
            console.error("Trying to parse unknown filetype");
        }
        return this;
    }

    createFromJSON( json ) {
        return new SituationImage().parseFromJSON( json );
    }

    create( json ) {
        var s = new SituationImage();
        Object.assign( s, json );
        return s;
    }

    toJSON() {
        var rv = super.toJSON();
        rv.sphereImageID = this.sphereImageID;
        return rv;
    }

    getContentIDs(){
       var contentIDs = [];
       contentIDs.push(this.getSphereImageID());
       return contentIDs;
    }
}

class SituationVideo extends Situation
{
    constructor( {
        id = -1,
        name = undefined,
        description = undefined,
        thumbnail = undefined,
        autoJump = undefined,
        autoJumpAtTime = undefined,
        autoJumpTarget = undefined,
        loop = undefined,
        videoWidth = undefined,
        videoHeight = undefined,
        exposedInUI = undefined,
        exposedUIHeader = undefined,
        sphereVideoID = undefined,
        autoplay = undefined,
        type = undefined
    } = {} ) {
        super( { id, type, name, description, thumbnail, autoJump, autoJumpAtTime, autoJumpTarget, loop, videoWidth, videoHeight, exposedInUI, exposedUIHeader } );
        this.setType( Prefab.PrefabType.SituationVideo );
        this.setSphereVideoID( sphereVideoID )
        this.setAutoplay(autoplay);
    }
    isOfType( type ) {
        return type === Prefab.PrefabType.SituationVideo || super.isOfType( type );
    }

    setSphereVideoID( value ) { this.sphereVideoID = value; return this; }    
    getSphereVideoID() { return this.sphereVideoID; }

    
    setAutoplay( value ) { this.autoplay = value; return this; }
    getAutoplay () { return this.autoplay; }
    
    // Parses this prefab type from the given JSON object
    parseFromJSON( json ) {
        // not implemented...
        if( json && json.presetType ) {
            // not implemented...
            super.parseFromJSON( json );

            // Seems to be a datatype from the CMS...
            this.setSphereVideoID( json.roomSphereVideo );
        } else {
            // Unknown datatype...
            console.error("Trying to parse unknown filetype");
        }
        return this;
    }

    createFromJSON( json ) {
        return new SituationVideo().parseFromJSON( json );
    }

    create( json ) {
        var s = new SituationVideo();
        Object.assign( s, json );
        return s;
    }


    toJSON() {
        var rv = super.toJSON();
        rv.sphereVideoID = this.sphereVideoID;
        return rv;
    }

    getContentIDs(){
        var contentIDs = [];
        contentIDs.push(this.getSphereVideoID());
        return contentIDs;
     }
}


class ContentPrefab extends Prefab
{
    constructor( {
        id = -1,
        situation = undefined,
        thumbnail = null,
        position = null,
        rotation = null,
        positionPixel = null,
        type = undefined
    } = {} ) {
        super( { id, type } );
        Object.assign( this, { situation, thumbnail, position, rotation, positionPixel });
    }
    isOfType( type ) {
        return type === Prefab.PrefabType.ContentPrefab || super.isOfType( type );
    }

    setSituation( value ) { this.situation = value; return this; }
    setThumbnail( thumbnail ) { this.thumbnail = thumbnail; return this; }
    setPosition( position ) { this.position = position; return this; }
    setPositionPixel( positionPixel ) { this.positionPixel = positionPixel; return this; }
    setRotation( rotation ) { this.rotation = rotation; return this; }

    getSituation() { return this.situation; }
    getSituationID() { return this.situation; }
    getThumbnail() { return this.thumbnail; }
    getPosition() { return this.position; }
    getPositionPixel() { return this.positionPixel; }
    getRotation() { return this.rotation; }

    setRotationX(value) { this.rotationX = value; return this;}
    setRotationY(value) { this.rotationY = value; return this;}
    setRotationZ(value) { this.rotationZ = value; return this;}

    getRotationX() { return this.rotationX; }
    getRotationY() { return this.rotationY; }
    getRotationZ() { return this.rotationZ; }


    // Parses this prefab type from the given JSON object
    parseFromJSON( json ) {
        // not implemented...
        if( json && json.presetType ) {
            // not implemented...
            super.parseFromJSON( json );

            // Seems to be a datatype from the CMS...
            this
            .setSituation( json.room )
            .setThumbnail( json.thumbnail )
            .setPosition( json.room_relative_position )
            .setPositionPixel( json.room_relative_position_pixel )
            .setRotation( json.rotation )
            .setRotationX( json.rotationX )
            .setRotationY( json.rotationY )
            .setRotationZ( json.rotationZ )
        
        } else {
            // Unknown datatype...
            console.error("Trying to parse unknown filetype");
        }
        return this;
    }

    createFromJSON() {

    }

    create() {
       
    }


    toJSON() {
        var rv = super.toJSON();
        rv.situation = this.situation;
        rv.thumbnail = this.thumbnail;
        rv.position = this.position;
        rv.positionPixel = this.positionPixel;
        rv.rotation = this.rotation;
        return rv;
    }

    getContentIDs(){
        return [];
     }
}




class VisualPrefab extends ContentPrefab
{
    constructor( {
        id = -1,
        situation = undefined,
        thumbnail = null,
        position = null,
        positionPixel = null,
        rotation = null,
        scale = null,
        billboard = false,
        type = undefined
    } = {} ) {
        super( { id, situation, thumbnail, position, positionPixel, rotation, type } );
        Object.assign( this, { scale, billboard });
    }
    isOfType( type ) {
        return type === Prefab.PrefabType.VisualPrefab || super.isOfType( type );
    }

    setScale( scale ) { this.scale = scale; return this; }
    setBillboard( billboard ) { this.billboard = billboard; return this; }

    getScale() { return this.scale; }
    getBillboard() { return this.billboard; }

    // Parses this prefab type from the given JSON object
    parseFromJSON( json ) {
        // not implemented...
        super.parseFromJSON( json );

        // Seems to be a datatype from the CMS...
        this
        .setScale( json.scale )
        .setBillboard( json.rotate_towards_user )
        return this;
    }

    createFromJSON() {

    }

    create() {
  
    }


    toJSON() {
        var rv = super.toJSON();
        rv.billboard = this.billboard;
        rv.scale = this.scale;
        return rv;
    }
    getContentIDs(){
        return [];
     }
}

class SphereContent extends VisualPrefab
{
    constructor( {
        id = -1,
        name = undefined,
        description = undefined,
        thumbnail = undefined,
        videoWidth = undefined,
        videoHeight = undefined,
        exposedInUI = undefined,
        exposedUIHeader = undefined,
        sphereImageID = undefined,
        type = undefined
    } = {} ) {
        super( { id, type, name, description, thumbnail, videoWidth, videoHeight, exposedInUI, exposedUIHeader } );
        this.setType( Prefab.PrefabType.SphereContent );
        this
            .setSphereImageID( sphereImageID )
    }
    isOfType( type ) {
        return type === Prefab.PrefabType.SphereContent || super.isOfType( type );
    }

    setSphereImageID( value ) { this.sphereImageID = value; return this; }    
    getSphereImageID() { return this.sphereImageID; }

    // Parses this prefab type from the given JSON object
    parseFromJSON( json ) {
        // not implemented...
        if( json && json.presetType ) {
            // not implemented...
            super.parseFromJSON( json );

            // Seems to be a datatype from the CMS...
            this.setSphereImageID( json.roomSphereImage );
          
        } else {
            // Unknown datatype...
            console.error("Trying to parse unknown filetype");
        }
        return this;
    }

    createFromJSON( json ) {
        return new SphereContent().parseFromJSON( json );
    }

    create( json ) {
        var s = new SphereContent();
        Object.assign( s, json );
        return s;
    }

    toJSON() {
        var rv = super.toJSON();
        rv.sphereImageID = this.sphereImageID;
        return rv;
    }

    getContentIDs(){
       var contentIDs = [];
       contentIDs.push(this.getSphereImageID());
       return contentIDs;
    }
}

class VideoContent extends VisualPrefab
{
    constructor( {
        id = -1,
        situation = undefined,
        thumbnail = null,
        position = null,
        positionPixel = null,
        rotation = null,
        billboard = false,
        scale = null,
        contentId = -1,
        iconID = -1,     
    } = {} ) 
    {
        super( { id, situation, thumbnail, position, positionPixel, rotation, billboard, scale, contentId, iconID } );
        this.setType( Prefab.PrefabType.VideoContent );
        this.autoJump = undefined,
        this.autoJumpAtTime = undefined,
        this.autoJumpTarget = undefined,
        this.autoplay = undefined,
        this.autoplayAtTime = undefined, 
        this.looping = undefined,
        this.clickable = undefined,
        this.volumeScale = undefined,
        this.rotationX = undefined,
        this.rotationY = undefined,
        this.rotationZ = undefined,
        this.rotation = undefined,
        this.width = undefined,
        this.height = undefined,
        this.displayThumbnailBeforeStart = undefined,
        this.displayThumbnailWhenPaused = undefined,
        this.distance = undefined,
        this.name = undefined,
        this.displayControls = undefined,
        this.enlargeOnClick = undefined
    }
    isOfType( type ) {
        return type === Prefab.PrefabType.VideoContent || super.isOfType( type );
    }

    setContentID( contentId ) { this.contentId = contentId; return this; }
    getContentID() { return this.contentId; }

    setIconID( iconID ) { this.iconID = iconID; return this; }
    getIconID() { return this.iconID; }

    setName( name ) { this.name = name; return this; }
    getName() { return this.name; }
    
    setAutoJump( value ) { this.autoJump = value; return this; }
    setAutoJumpAtTime( value ) { this.autoJumpAtTime = value; return this; }
    setAutoJumpTarget( value ) { this.autoJumpTarget = value; return this; }

    setAutoplay( value ) { this.autoplay = value; return this; }
    setAutoplayAtTime( value ) { this.autoplayAtTime = value; return this; }
    setLooping( value ) { this.looping = value; return this; }
    setClickable( value ) { this.clickable = value; return this; }
    setVolumeScale( value ) { this.volumeScale = value; return this; }
    setDisplayThumbnailBeforeStart( value ) { this.displayThumbnailBeforeStart = value; return this; }
    setDisplayThumbnailWhenPaused( value ) { this.displayThumbnailWhenPaused = value; return this; }
    setDistance( value ) { this.distance = value; return this; }
    setDisplayControls( value ) { this.displayControls = value; return this; }
    setEnlargeOnClick( value ) { this.enlargeOnClick = value; return this; }
    
    setRotationX(value) { this.rotationX = value; return this;}
    setRotationY(value) { this.rotationY = value; return this;}
    setRotationZ(value) { this.rotationZ = value; return this;}
    setWidth(value) { this.width = value; return this;}
    setHeight(value) { this.height = value; return this;}

    getAutoJump() { return this.autoJump; }
    getAutoJumpAtTime() { return this.autoJumpAtTime; }
    getAutoJumpTarget() { return this.autoJumpTarget; }
    getAutoplay() { return this.autoplay; }
    getAutoplayAtTime() { return this.autoplayAtTime; }
    getLooping() { return this.looping; }
    getClickable() { return this.clickable; }
    getVolumeScale() { return this.volumeScale; }
    getDisplayControls() { return this.displayControls; }
    getEnlargeOnClick() { return this.enlargeOnClick; }

    getRotationX() { return this.rotationX; }
    getRotationY() { return this.rotationY; }
    getRotationZ() { return this.rotationZ; }
    getWidth() { return this.width; }
    getHeight() { return this.height; }

    getDisplayThumbnailBeforeStart() { return this.displayThumbnailBeforeStart; }
    getDisplayThumbnailWhenPaused() { return this.displayThumbnailWhenPaused; }
    getDistance() { return this.distance; }



    parseFromJSON( json ) {
        // not implemented...
        if( json ) { // && json.presetType === this.PrefabType.ImageContent ) {
            super.parseFromJSON( json );
        
            // Seems to be a datatype from the CMS...
            this.setContentID( json.video )
            this.setIconID( json.video )
            this.setAutoJump( json.autoJump )
            this.setAutoJumpAtTime( json.autoJumpAtTime )
            this.setAutoJumpTarget( json.autoJumpTarget )
            this.setAutoplayAtTime( json.autoPlayAtTime )
            this.setAutoplay( json.autoplay )
            this.setLooping( json.looping )
            this.setDistance ( json.distance )
            this.setClickable ( json.clickable )
            this.setVolumeScale ( json.volume_scale )
            this.setDisplayThumbnailBeforeStart ( json.displayThumbnailBeforeStart )
            this.setDisplayThumbnailWhenPaused ( json.displayThumbnailWhenPaused )
            this.setRotationX ( json.rotationX )
            this.setRotationY ( json.rotationY )
            this.setRotationZ ( json.rotationZ )
            this.setRotation ( json.rotation ) 
            this.setWidth ( json.width )
            this.setHeight ( json.height )
            this.setName(json.name)
            this.setDisplayControls(json.display_controls)
            this.setEnlargeOnClick(json.enlarge_on_click);
        } else {
            // Unknown datatype...
            console.error("Trying to parse unknown prefab type");
        }
        return this;
    }

    createFromJSON( json ) {
        return new VideoContent().parseFromJSON( json );
    }    

    create( json ) {
        var v = new VideoContent();
        Object.assign( v, json );
        return v;
    }


    toJSON() {
        var rv = super.toJSON();
        rv.contentID = this.contentID;
        rv.iconID = this.iconID;
        return rv;
    }

    getContentIDs(){
        var contentIDs = [];
        contentIDs.push(this.getContentID());
        return contentIDs;
     }
}


class ImageContent extends VisualPrefab
{
    constructor( {
        id = -1,
        situation = undefined,
        thumbnail = null,
        position = null,
        positionPixel = null,
        rotation = null,
        billboard = false,
        scale = null,
        imageID = -1,
        iconID = -1,
    } = {} ) 
    {
        super( { id, situation, thumbnail, position, positionPixel, rotation, billboard, scale, imageID, iconID } );
        this.setType( Prefab.PrefabType.ImageContent );
    }
    isOfType( type ) {
        return type === Prefab.PrefabType.ImageContent || super.isOfType( type );
    }

    setImageID( imageID ) { this.imageID = imageID; return this; }
    getImageID() { return this.imageID; }

    setIconID( iconID ) { this.iconID = iconID; return this; }
    getIconID() { return this.iconID; }

    parseFromJSON( json ) {
        // not implemented...
        if( json ) { // && json.presetType === this.PrefabType.ImageContent ) {
            super.parseFromJSON( json );

            // Seems to be a datatype from the CMS...
            this
            .setImageID( json.image )
            this
            .setIconID( json.image )
        } else {
            // Unknown datatype...
            console.error("Trying to parse unknown prefab type");
        }
        return this;
    }

    createFromJSON( json ) {
        return new ImageContent().parseFromJSON( json );
    }    

    create( json ) {
        //console.log("ImageContent json:")
        //console.log(json)
        var ic = new ImageContent();
        Object.assign( ic, json );
        return ic;
    }

    toJSON() {
        var rv = super.toJSON();
        rv.imageID = this.imageID;
        rv.iconID = this.iconID;
        return rv;
    }

    getContentIDs(){
        var contentIDs = [];
        contentIDs.push(this.getImageID());
        return contentIDs;
     }
}

class URLButtonContent extends ImageContent
{
    constructor( {
        id = -1,
        situation = undefined,
        thumbnail = null,
        position = null,
        positionPixel = null,
        rotation = null,
        billboard = false,
        scale = null,
        imageID = -1,
        url = undefined,
        displayInternally = undefined,
        displayUrl = undefined, 
        outTrigger = undefined,
        overTrigger = undefined
    } = {} ) 
    {
        super( { id, situation, thumbnail, position, positionPixel, rotation, billboard, imageID, scale } );
        this.setType( Prefab.PrefabType.URLButton );
        this.URL = url;
        this.displayInternally = displayInternally;
        this.displayUrl = displayUrl;
        this.outTrigger  = outTrigger;
        this.overTrigger  = overTrigger;
        
    }
    isOfType( type ) {
        return type === Prefab.PrefabType.URLButton || super.isOfType( type );
    }

    setURL( url ) { this.URL = url; return this; }
    getURL() { return this.URL; }
    setdisplayInternally( displayInternally ) { this.displayInternally = displayInternally; return this; }
    getdisplayInternally() { return this.displayInternally; }
    setdisplayUrl( displayUrl ) { this.displayUrl = displayUrl; return this; }
    getdisplayUrl() { return this.displayUrl; }

    setOutTrigger (trigger){ this.outTrigger = trigger; return this;}
    getOutTrigger() {return this.outTrigger;}
    setOverTrigger (trigger){ this.overTrigger = trigger; return this;}
    getOverTrigger() {return this.overTrigger;}


    parseFromJSON( json ) {
        // not implemented...
        if( json ) {
            super.parseFromJSON( json );
      
            // Seems to be a datatype from the CMS...
            this
            .setURL( json.URL )
            .setIconID(json.Vorschaubild)
            .setImageID(json.Vorschaubild)
            .setdisplayInternally(json.display_internally)
            .setdisplayUrl(json.show_url)
            .setOutTrigger(json.outTrigger)
            .setOverTrigger(json.overTrigger)
         
        } else {
            // Unknown datatype...
            console.error("Trying to parse unknown prefab type");
        }
        return this;
    }

    createFromJSON( json ) {
        return new URLButtonContent().parseFromJSON( json );
    }    

    toJSON() {
        var rv = super.toJSON();
        rv.url = this.URL;
        return rv;
    }

    create( json ) {
        //console.log("Creating URL Button")
        //console.log(json)
        var ub = new URLButtonContent();
        Object.assign( ub, json );
        ub.relative_position = json.position;
        //console.log(ub)
        return ub;
    }

    getContentIDs(){        
        var contentIDs = [];
        contentIDs.push(this.getIconID());
        return contentIDs;
     }
}



class AudioContent extends ContentPrefab
{
    constructor( {
        id = -1,
        situation = undefined,
        thumbnail = null,
        position = null,
        positionPixel = null,
        audioID = -1,
        looping = false,
        autoplay = true,
        autoplayAtTime = 0,
        clickable = false,
        volumeScale = 50,
        distance = 1,
        isAmbient = false,
    } = {} ) 
    {
        super( { id, situation, thumbnail, position, positionPixel } );
        this.setType( Prefab.PrefabType.AudioContent );
        Object.assign( this, { audioID, looping, autoplay, autoplayAtTime, clickable, volumeScale, distance, isAmbient });
    }
    isOfType( type ) {
        return type === Prefab.PrefabType.AudioContent || super.isOfType( type );
    }

    setAudioID( audioID ) { this.audioID = audioID; return this; }
    setLooping ( looping ) { this.looping = looping; return this; }    
    setAutoplay( autoplay ) { this.autoplay = autoplay; return this; }
    setAutoplayAtTime ( autoplayAtTime) {this.autoplayAtTime = autoplayAtTime; return this; }
    setClickable ( clickable ) {this.clickable = clickable; return this; }
    setVolumeScale  (volumeScale ) {this.volumeScale = volumeScale; return this;}
    setDistance ( distance ) {this.distance = distance; return this; }
    setIsAmbient( isAmbient ) {this.is_ambient = isAmbient; return this;}
  
    getAudioID() { return this.audioID; }
    getLooping () { return this.looping;} 
    getAutoplay() { return this.autoplay; }
    getAutoplayAtTime() {return this.autoplayAtTime;} 
    getClickable () { return this.clickable;}
    getVolumeScale () { return this.volumeScale;}
    getDistance () { return this.distance;}
    getIsAmbient() { return this.isAmbient;}
   
    parseFromJSON( json ) {
        // not implemented...
         
        //console.log("Parsing json Audio ");
        if( json ){ //&& json.presetType === this.PrefabType.AudioContent ) {
            super.parseFromJSON( json );

            // Seems to be a datatype from the CMS...
            this
            .setAudioID( json.audio )
            .setIsAmbient( json.is_ambient )
            .setAutoplay (json.autoplay )
            .setAutoplayAtTime( json.autoplay_at_time )
            .setType( json.presetType )
            .setLooping( json.looping )
            .setClickable( json.clickable )
            .setVolumeScale( json.volume_scale )
            .setDistance( json.distance )
            .setIsAmbient( json.is_ambient )
            
        } else {
            // Unknown datatype...
            console.error("Trying to parse unknown prefab type");
        }
        return this;
    }

    createFromJSON( json ) {
        return new AudioContent().parseFromJSON( json );
    }

    create( json ) {
        var ac = new AudioContent();
        Object.assign( ac, json );
        return ac;
    }

    toJSON() {
        var rv = super.toJSON();
        rv.audioID = this.audioID;
        rv.looping = this.looping;
        rv.autoplay = this.autoplay;
        rv.autoplayAtTime = this.autoplayAtTime;
        rv.clickable = this.clickable;
        rv.volumeScale = this.volumeScale;
        rv.distance = this.distance;
        rv.isAmbient = this.isAmbient;
        return rv;
    }
    getContentIDs(){
        var contentIDs = [];
        contentIDs.push(this.getAudioID());
        return contentIDs;
     }
}

class Viewer3D extends ImageContent
{
    constructor( {
        id = -1,
        situation = undefined,
        thumbnail = null,
        position = null,
        positionPixel = null,
        rotation = null,
        billboard = false,
        scale = null,
        imageID = -1,
        url = undefined,
    } = {} ) 
    {
        super( { id, situation, thumbnail, position, positionPixel, rotation, billboard, imageID, scale } );
        this.setType( Prefab.PrefabType.Viewer3D );
        this.URL = url;
        this.scaleX = undefined;
        this.scaleY = undefined;
        this.scaleZ = undefined;
        this.name = undefined;
    }
    isOfType( type ) {
        return type === Prefab.PrefabType.Viewer3D || super.isOfType( type );
    }

    setURL( url ) { this.URL = url; return this; }
    getURL() { return this.URL; }

    setScaleX( scaleX ) { this.scaleX = scaleX; return this; }
    getScaleX() { return this.scaleX; }
    setScaleZ( scaleZ ) { this.scaleZ = scaleZ; return this; }
    getScaleZ() { return this.scaleZ; }
    setScaleY( scaleY ) { this.scaleY = scaleY; return this; }
    getScaleY() { return this.scaleY; }
    setName( name ) { this.name = name; return this; }
    getName() { return this.name; }

    parseFromJSON( json ) {
        // not implemented...
        if( json ) {
            super.parseFromJSON( json );
      
            // Seems to be a datatype from the CMS...
            this
            .setURL( json.URL )
            .setIconID(json.Vorschaubild)
            .setImageID(json.Vorschaubild)
            .setScaleX(json.scaleX)
            .setScaleY(json.scaleY)
            .setScaleZ(json.scaleZ)
            .setName(json.name)
         
        } else {
            // Unknown datatype...
            console.error("Trying to parse unknown prefab type");
        }
        return this;
    }

    createFromJSON( json ) {
        return new Viewer3D().parseFromJSON( json );
    }    

    
    create( json ) {
        var v = new Viewer3D();
        Object.assign( v, json );
        return v;
    }

    toJSON() {
        var rv = super.toJSON();
        rv.url = this.URL;
        return rv;
    }

    getContentIDs(){        
        var contentIDs = [];
        contentIDs.push(this.getIconID());
        return contentIDs;
     }
}


class Transition extends VisualPrefab
{
    constructor( {
        id = -1,
        situation = undefined,
        thumbnail = null,
        position = null,
        positionPixel = null,
        rotation = null,
        billboard = false,
        scale = null,
        targetID = -1,
        imageID = -1,
        iconID = -1,
        targetRotation = null,
        targetRotationOverwrite = null,
        automaticJump = null,
        targetLocationID = null,
        outTrigger = undefined,
        overTrigger = undefined,
        pickTrigger = undefined,
        visible = undefined
    } = {} ) 
    {
        super( { id, situation, thumbnail, position, positionPixel, rotation, billboard, scale } );
        this.setType( Prefab.PrefabType.Transition );
        Object.assign( this, { targetID, imageID, targetRotation, targetRotationOverwrite, targetLocationID, automaticJump, iconID, outTrigger, overTrigger, pickTrigger, visible});
    }
    isOfType( type ) {
        return type === Prefab.PrefabType.Transition || super.isOfType( type );
    }

    setTargetID( target ) { this.targetID = target; return this; }
    setImageID( id ) { this.imageID = id; return this; }
    setIconID( id ) { this.iconID = id;  return this; }
    
    setOutTrigger (trigger){ this.outTrigger = trigger; return this;}
    getOutTrigger() {return this.outTrigger;}
    setOverTrigger (trigger){ this.overTrigger = trigger; return this;}
    getOverTrigger() {return this.overTrigger;}
    setPickTrigger (trigger){ this.pickTrigger = trigger; return this;}
    getPickTrigger() {return this.pickTrigger;}

    setVisible (visible){ this.visible = visible; return this;}
    getVisible() {return this.visible;}

    setTargetRotation ( rotation ){ this.targetRotation = rotation; return this; }
    setTargetRotationOverwrite ( overwrite ){ this.targetRotationOverwrite = overwrite; return this; }
    setTargetLocationID( targetLocationID ) { this.targetLocationID = targetLocationID; return this; }
    setAutomaticJump ( jump ){this.automaticJump = jump; return this; }


    getTargetID() { return this.targetID; }
    getImageID() { return this.imageID; }
    getIconID() { return this.iconID;}
    getTargetRotation() { return this.targetRotation; }
    getTargetRotationOverwrite() { return this.targetRotationOverwrite; }
    getTargetLocationID() { return this.targetLocationId; }
    getAutomaticJump (){return this.automaticJump}

    parseFromJSON( json ) {
        // not implemented...
        if( json && json.presetType === Prefab.PrefabType.Transition ) {
            super.parseFromJSON( json );

            // Seems to be a datatype from the CMS...
            this
            .setTargetID( json.target_location_id )
            .setImageID( json.Icon )
            .setIconID( json.Icon )
            .setTargetRotation (json.target_rotation ? json.target_rotation : undefined)
            .setTargetRotationOverwrite(json.target_rotation_overwrite ? json.target_rotation_overwrite : undefined)
            .setType( json.presetType )
            .setAutomaticJump ( json.automatic_jump )
            .setOutTrigger (json.outTrigger)
            .setOverTrigger (json.overTrigger)
            .setPickTrigger (json.pickTrigger)
            .setVisible (json.visible)

        } else {
            // Unknown datatype...
            console.error("Trying to parse unknown prefab type");
        }
        return this;
    }

    createFromJSON( json ) {
        return new Transition().parseFromJSON( json );
    }

     
    create( json ) {
        var t = new Transition();
        Object.assign( t, json );
        return t;
    }

    toJSON() {
        var rv = super.toJSON();
        rv.targetID = this.targetID;
        rv.imageID = this.imageID;
        rv.iconID = this.iconID;        
        rv.targetRotation = this.targetRotation;
        rv.targetRotationOverwrite = this.targetRotationOverwrite;
        rv.automaticJump = this.automaticJump;
        rv.outTrigger = this.outTrigger;
        rv.overTrigger = this.overTrigger;
        rv.pickTrigger = this.pickTrigger;
        return rv;
    }    
    getContentIDs(){
        var contentIDs = [];
        contentIDs.push(this.getImageID());
        return contentIDs;
     }
}




class TextContent extends VisualPrefab
{
    constructor( {
        id = -1,
        situation = undefined,
        thumbnail = null,
        position = null,
        positionPixel = null,
        rotation = null,
        billboard = false,
        scale = null,
        displayedText = null,
        displayOnClick = null,
        previewText = null,
        textID = -1,
    } = {} ) 
    {
        super( { id, situation, thumbnail, position, positionPixel, rotation, billboard, scale } );
        this.setType( Prefab.PrefabType.TextContent );
        Object.assign( this, { textID, displayedText, displayOnClick, previewText});
    }
    isOfType( type ) {
        return type === Prefab.PrefabType.TextContent || super.isOfType( type );
    }

    setIconID( iconID ) { this.iconID = iconID; return this; }
    getIconID() { return this.iconID; }

    setTextID( textID ) { this.textID = textID; return this; }
    setDisplayedText( text ) {this.displayedText = text; return this;}
    setDisplayOnClick( val ) {this.displayOnClick = val; return this;}
    setPreviewText( val ) {this.previewText = val; return this;}

    getTextID() { return this.textID; }
    getDisplayedText () {return this.displayedText; }
    getDisplayOnClick () {return this.displayOnClick; }
    getPreviewText () {return this.previewText; }
    

    toJSON() {
        var rv = super.toJSON();
        rv.textID = this.textID;
       
        return rv;
    }

    parseFromJSON( json ) {
        // not implemented...
        if( json ) {
            super.parseFromJSON( json );
            // Seems to be a datatype from the CMS...
            this
            .setDisplayedText(json.displayed_text)
            .setDisplayOnClick(json.display_on_click)
            .setIconID(json.Image)
            .setPreviewText(json.preview_text);
         
        } else {
            // Unknown datatype...
            console.error("Trying to parse unknown prefab type");
        }
        return this;
    }


    createFromJSON( json ) {
        return new TextContent().parseFromJSON( json );
    }

    create( json ) {
        var rv = new TextContent();
        Object.assign( rv, json );
        return rv;
    }

    getContentIDs(){
        var contentIDs = [];
        contentIDs.push(this.getIconID());
        return contentIDs;
     }
}

class PrefabBuilder {
    constructor() {
        this.supportedPrefabTypes = new Map();
    }

    registerPrefabType( prefab ) {
        if( prefab.getType ) {
            this.supportedPrefabTypes.set( prefab.getType(), prefab );
        }
    }

    createFromJSON( json ) {
        if( json && json.presetType ) {
            if( this.supportedPrefabTypes.has( json.presetType ) )        
                return this.supportedPrefabTypes.get( json.presetType ).createFromJSON( json );
            else
                console.log("Unknown preset type " + json.presetType );
        } else {
            // Unknown datatype...
            console.error("Trying to parse unknown preset type ");
        }
    }

    
    create( json ) {
       
        if( json && json.type ) {
             /*
            if(json.type == "Button, der einen Weblink öffnet")
                json.type = "URLButtonContent"
                else if(json.type == "RoomContentJumper")
                json.type = "Transition"
                else if(json.type == "RoomVideo")
                json.type = "VideoContent"
                else if(json.type == "RoomVideo")
                json.type = "VideoContent"
*/
            if( this.supportedPrefabTypes.has( json.type ) )        
                return this.supportedPrefabTypes.get( json.type ).create( json );
            else
                console.log("Unknown preset type " + json.type );
        } else {
            // Unknown datatype...
            console.error("Trying to parse unknown preset type ");
        }
    }
   

}

const PrefabBuilderInstance = new PrefabBuilder();
Object.freeze(PrefabBuilderInstance);

PrefabBuilderInstance.registerPrefabType( new Viewer3D() );
PrefabBuilderInstance.registerPrefabType( new Application360() );
PrefabBuilderInstance.registerPrefabType( new AudioContent() );
PrefabBuilderInstance.registerPrefabType( new Transition() );
PrefabBuilderInstance.registerPrefabType( new ImageContent() );
PrefabBuilderInstance.registerPrefabType( new VideoContent() );
PrefabBuilderInstance.registerPrefabType( new URLButtonContent() );
PrefabBuilderInstance.registerPrefabType( new SituationImage() );
PrefabBuilderInstance.registerPrefabType( new SituationVideo() );
PrefabBuilderInstance.registerPrefabType( new TextContent() );
PrefabBuilderInstance.registerPrefabType( new SphereContent() );


export { Prefab, PrefabBuilder, AudioContent, VideoContent, ImageContent, Transition, Viewer3D, URLButtonContent, Application360, SituationImage, SituationVideo, TextContent, SphereContent, PrefabBuilderInstance, RuntimeState }